<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="部门名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入部门名称" />
      </el-form-item>
      <el-form-item label="总监" prop="idx">
        <el-select v-model="form.idx" filterable clearable placeholder="请选择部门绑定的总监">
          <el-option v-for="item in technicianList" :key="item.idx" :label="item.name" :value="item.idx"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>{{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysDepartmentApi from '@/api/config/sysDepartment'
import technicianInfoApi from '@/api/technical/technicianInfo'
import customerApi from '@/api/technical/customer'
function initFormBean() {
  const formBean = {
    name: null,
    idx: null,
    isEnable: false,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
        idx: [{ required: true, message: '请选择部门绑定的总监', trigger: 'change' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false,
      technicianList: []
    }
  },
  created() {
    this.getTechnicianList()
    this.getCustomer()
  },
  methods: {
    // 获取技术老师列表
    getTechnicianList() {
      technicianInfoApi.listForMini({ 
        levelId: 1, 
        status: 10 
      }).then(({ data }) => {
        data.forEach(item => {
          item.idx = 'a_' + item.id
          item.name = item.realName
          item.directorUserType = 30
        })
        this.technicianList = this.technicianList.concat(data)
      })
    },
    getCustomer() {
      customerApi.listForMini({ CLevel: 1, isDeparted: 0 }).then(({ data }) => {
        data.forEach(item => {
          item.idx = 'b_' + item.id
          item.directorUserType = 20
        });
        this.technicianList = this.technicianList.concat(data)
      })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      if (row.directorUserType === 20) {
        this.$set(this.form, 'idx', 'b_' + row.directorUserInfoId)
      } else if (row.directorUserType === 30) {
        this.$set(this.form, 'idx', 'a_' + row.directorUserInfoId)
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcParams() {
      let { name, idx, isEnable, id } = this.form;
      let find = this.technicianList.find(item => item.idx === idx)
      let params = {
        directorUserId: find.userId,
        directorUserInfoId: find.id,
        directorUserType: find.directorUserType,
        isEnable, name
      }
      if (id) params.id = id
      return params
    },
    /**
     * 执行新建操作
     */
    doCreate() {

      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          let params = this.calcParams()
          if (this.form.id > 0) {
            sysDepartmentApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            sysDepartmentApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
</style>
